<template>
  <div class="card-body py-3" v-if="!isLoaded || !isEmpty(organisation.highlights.about)">
    <div class="d-flex justify-content-between">
      <h3 class="mb-0 t-md t-400">
        About
      </h3>
      <i class="fa fa-quote-left t-secondary t-lr" />
    </div>
    <long-text  v-if="isLoaded" :text="organisation.highlights.about" :truncateAt="500" :isRichText="false" class="mt-3 t-400" />
    <!-- render spinner if not loaded -->
    <spinner v-if="!isLoaded" :containerClass="`width--50px min-height--150px`" />
  </div>
</template>

<script>
import Spinner from '@/components/shared/Spinner'
import LongText from '@/components/shared/LongText'

export default {
  name: 'organisationAbout',
  components: {
    Spinner,
    LongText
  },
  props: {
    isLoaded: {
      type: Boolean,
      required: true
    },
    organisation: {
      type: Object,
      required: true
    }
  }
}
</script>
